import * as tslib_1 from "tslib";
import React from 'react';
import UserLink from '../../../User/Link';
var MentionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MentionComponent, _super);
    function MentionComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MentionComponent.prototype.render = function () {
        if (!this.props || !this.props.componentData) {
            return null;
        }
        var mention = this.props.componentData.mention;
        if (!mention || !mention.name) {
            return null;
        }
        if (mention.type) {
            var user = {
                type: mention.type || 'standard',
                username: mention.name,
                userId: mention.userId || 0,
                useridUuid: mention.userUuid || '',
                usericon: mention.avatar,
                isNewDeviant: false,
            };
            return (React.createElement(UserLink, { key: mention.name, user: user, withTooltip: true, className: "editor-mention-link" }));
        } // Fallback when we dont have enough info for user
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { href: "https://www.deviantart.com/" + mention.name
                    .toLowerCase()
                    .replace(/^@/, ''), title: mention.name }, "" + mention.name)));
    };
    return MentionComponent;
}(React.Component));
export default MentionComponent;
//# sourceMappingURL=mentionComponent.js.map